/** @format */

import { find, includes, trim } from 'lodash';
import { pageAccessRoles } from 'src/config';

export const checkRoleAcceptAccessPage = (path, accessControls) => {
  const trimPath = trim(path, '/');
  const includedKey = find(pageAccessRoles, (_value, pathCheck) => {
    return includes(trimPath, trim(pathCheck, '/'));
  });

  if (includedKey) {
    return includes(accessControls, includedKey);
  }
  return true;
};
